import React from 'react';
import {
  Equivalent_to_KHR,
  getSubCategoryId,
  number_50_00,
  phone_number,
  send_money,
} from '../utils/DictionaryManagementUtils';
import MenuManualRecipient from '../components/ManulRecipient/MenuManualRecipient';
import MenuManualListFP
  from '../components/SimulatorsComponents/FullPagesComponents/Services/Recipient/MenuManualListFP';
import FullPageSimulator from '../components/SimulatorsComponents/FullPagesComponents/FullPageSimulator';
import AmountMenuFP from '../components/SimulatorsComponents/FullPagesComponents/Services/Amount/AmountMenuFP';
import ConfirmTransferFP
  from '../components/SimulatorsComponents/FullPagesComponents/Services/Confirmation/ConfirmTransferFP';
import SimulatorsViewerArrangement
  from '../components/SimulatorsComponents/FullPagesComponents/SimulatorsViewerArrangement';
//= ========================================================================
const Sim_X01_themeRadius = ({
  globJSON,
  simPlatform,
  slideshowRefs,
}) => {
  const subCategoryId = getSubCategoryId({
    sub_category: send_money,
    duplication_number: 0,
  });
  const { colors } = globJSON.configurations.theme;
  const manualName = phone_number;
  const manual_recipient = globJSON.configurations.services[subCategoryId].recipient.manual_recipients[manualName];
  const { confirmation } = globJSON.configurations.services[subCategoryId];
  const { recipient } = globJSON.configurations.services[subCategoryId];

  return (
    <SimulatorsViewerArrangement>
      <MenuManualListFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        recipient={recipient}
        slideshowRefs={slideshowRefs}
      />
      <FullPageSimulator
        globJSON={globJSON}
        simPlatform={simPlatform}
        headlineText={manual_recipient.enter_details}
        slideshowRefs={slideshowRefs}
      >
        <MenuManualRecipient
          globJSON={globJSON}
          simPlatform={simPlatform}
          manualName={manualName}
          subCategoryId={subCategoryId}
          isFormFilled
        />
      </FullPageSimulator>
      <AmountMenuFP
        amount={globJSON.configurations.services.send_money_0.amount}
        globJSON={globJSON}
        simPlatform={simPlatform}
        subCategoryId={subCategoryId}
        priceAmount={number_50_00}
        showConvert={Equivalent_to_KHR}
        IconBackgroundColor={colors.primary_cta_color}
        checkbox
        isMenu
        slideshowRefs={slideshowRefs}
      />
      <ConfirmTransferFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        confirmation={confirmation}
        subCategoryId={subCategoryId}
        headlineText={confirmation.does_it_look_ok}
        withoutIconLine
        slideshowRefs={slideshowRefs}
      />
    </SimulatorsViewerArrangement>
  );
};

export default Sim_X01_themeRadius;
